import request from './request'

export function loginH5(payload) {
  return request({
    url: '/api/gui-admin/auth/login',
    method: 'post',
    data: {
      email: payload?.email,
      password: payload?.password,
    },
  })
}

export function fetchCurrentH5User(options = {}) {
  return request({
    url: '/api/gui-admin/auth/me',
    method: 'get',
    skipAuthRedirect: options.skipAuthRedirect,
  })
}

export function logoutH5(options = {}) {
  return request({
    url: '/api/gui-admin/auth/logout',
    method: 'post',
    skipAuthRedirect: options.skipAuthRedirect,
  })
}
